import ScrollHandler from './scrollHandler'

export default ScrollHandler